import { useContext } from 'react';
import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';
import { CompanyContext } from '../../../../Contexts/CompanyContext';
import { FaClock } from 'react-icons/fa';
import { MdExitToApp } from 'react-icons/md';
import { useAuth } from 'oidc-react';
import './styles.css';
import { BsBuilding } from 'react-icons/bs';
import { TimeoutContext } from '../../../../Contexts/TimeoutContext';

const NavbarConfiguration = () => {
    const { company } = useContext(CompanyContext);
    const { minutes, seconds } = useContext(TimeoutContext);
    const { pathname } = useLocation();

    const auth = useAuth();
    let userData = auth?.userData;
    const name = userData?.profile[ 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name' ];
    var nameSplited = name.split(" ");

    const Logout = () => {
        window.location.href = auth.userManager.settings.authority?.toString() ?? "";
    }

    return (
        <Navbar collapseOnSelect expand="lg" className='back-white'>
            <Container fluid className='d-flex w-100 align-items-center justify-content-between'>
                <Navbar.Brand href={`/home/${company.id}`}>
                    <img src={'img/logo-fin.svg'} alt="logo" />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse className='justify-content-end' id="responsive-navbar-nav">
                    <Nav className='last-child'>
                        <div title='Tempo para Timeout' className={`d-flex align-items-center justify-content-center countdown ${minutes <= 1 ? "time-red" : minutes <= 2 ? "time-orange" : ""}`}>
                            <FaClock className='me-1' />
                            <span id="minute">{minutes < 10 ? "0" + minutes : minutes}:</span>
                            <span id="second">{seconds < 10 ? "0" + seconds : seconds}</span>
                        </div>
                        <NavDropdown
                            active={
                                pathname.includes("documentManager") ||
                                pathname.includes("configurations")
                            }
                            title={
                                <span>Olá, {`${nameSplited[ 0 ]} ${nameSplited.length > 1 && nameSplited[ nameSplited.length - 1 ]}`}</span>
                            }
                            id="navbarScrollingNavDropdown"
                        >
                            <NavDropdown.Item
                                as={NavLink}
                                to={'/Companies/ChangeCompany/IsChange=true'}
                            >
                                <BsBuilding className="me-2" />
                                Mudar de Empresa
                            </NavDropdown.Item>
                        </NavDropdown>
                        <div className="d-flex align-items-center">
                            <button className='button-exit' onClick={Logout}>
                                <MdExitToApp className="me-2" />
                                <span>Sair</span>
                            </button>
                        </div>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
}

export default NavbarConfiguration;
